const tagManagement = require('od-modules/utils/tag_management.utils');
const trackingUtils = require('od-modules/utils/tracking.utils');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const onboardingFunnelVersion = Odigeo.Membership.isMembershipOnboardingFunnelV2 ? '_v2' : '';
const membershipOnboardingManagerFactory = () => import('components/membership/membership_onboarding_manager'+onboardingFunnelVersion+'/js/main')
    .then(({default: factory}) => factory);

const pageSetup = (pageName, pageClass) => {
    $('#page').removeClass().addClass(`${pageName} ${pageClass}`);
    Odigeo.Session.set('page', pageName);
    Odigeo._.extend(Odigeo.Model.prototype, {
        error500() {},
    });
};

const trackingSetup = (pageHash) => {
    trackingUtils.trackPage(pageHash, {funnel: false});
    tagManagement.updateDatalayer();
};

Odigeo.Router.handlers.membership_onboarding = function() {
    const pageName = 'membership_onboarding';
    const pageClass = 'od-membership-onboarding';
    const pageHash = 'prime/onboarding';
    const onboardingViewName = onboardingFunnelVersion ? 'membership-onboarding-view-v2' : 'membership-onboarding-view';

    const widgetLoader = createWidgetLoader({
        membershipOnboardingManager: ['membership-onboarding-manager', membershipOnboardingManagerFactory()],
    });

    const asyncWidgets = Odigeo.autoloadWidgetsAsync({
        getUsersManager: ['users-manager', 'usersmanager'],
        getMembershipManager: ['membership-manager', 'membership_manager'],
    });
    Odigeo.Router.eventController = $.extend(true,
        Odigeo.Router.eventController,
        Odigeo.Router.handlers.globalEventController,
        Odigeo.Router.handlers.userEventController,
        {
            globalEvents: {},
            viewEvents: {
                'membership-onboarding-manager:getTokenInfo': 'onGetTokenInfo',
                'membership-manager:getTokenInfoOk': 'onGetTokenInfoOk',
                'membership-manager:getTokenInfoFail': 'onGetTokenInfoFail',
                [`${onboardingViewName}:submitUserRequest`]: 'onSubmitUserRequest',
                [`${onboardingViewName}:trackEvent`]: 'onTrackEvent',
                [`${onboardingViewName}:trackPage`]: 'onTrackPage',
                'users-manager:changePasswordWithCodeOk': 'onChangePasswordSuccess',
                'users-manager:changePasswordWithCodeWithError': 'onChangePasswordError',
                'users-manager:changePasswordWithCodeError': 'onChangePasswordError',
            },
            eventHandlers: {
                onGetTokenInfo(token) {
                    asyncWidgets.getMembershipManager().execute('getTokenInfo', token);
                },

                onGetTokenInfoOk(info) {
                    widgetLoader.get('membershipOnboardingManager').execute('setTokenInfo', info);
                },

                onGetTokenInfoFail() {
                    Odigeo.Utils.goToApplicationHome();
                },

                onSubmitUserRequest(data) {
                    asyncWidgets.getUsersManager().execute('submitUserRequest', data);
                },

                onChangePasswordSuccess() {
                    widgetLoader.get('membershipOnboardingManager').execute('changePasswordSuccess');
                },

                onChangePasswordError() {
                    widgetLoader.get('membershipOnboardingManager').execute('changePasswordError');
                },

                onTrackEvent(category, action, label) {
                    trackingUtils.trackEventWithCategory(category, action, label);
                },

                onTrackPage(page) {
                    trackingSetup(`${pageHash}/${page}`);
                },
            },

        }
    );

    pageSetup(pageName, pageClass);
    trackingSetup(pageHash);

    // Initialize
    Odigeo.Router.eventController.execute();
    Odigeo.Utils.sessionTimer.reset();

    widgetLoader.get('membershipOnboardingManager');
};
